module.exports = __webpack_public_path__ + "static/media/logo.a227f92f.png";